import { YOCKeyIcon as KeyIcon } from 'yoc-ui-library/icons';

import ClickIcon from './click-icon.svg?react';
import EnvelopeIcon from './envelope-icon.svg?react';
import ExportIcon from './export-icon.svg?react';
import EyeIcon from './eye-icon.svg?react';
import FileExcelIcon from './file-excel-icon.svg?react';
import FilePdfIcon from './file-pdf-icon.svg?react';
import GlobeIcon from './globe-icon.svg?react';
import GraphIcon from './graph-icon.svg?react';
import MoneyIcon from './money-icon.svg?react';
import PhoneIcon from './phone-icon.svg?react';
import ProductIcon from './product-icon.svg?react';
import QRCodeIcon from './qrcode-icon.svg?react';
import ReportActionsIcon from './report-actions-icon.svg?react';
import SettingsIcon from './settings-icon.svg?react';
import SparkleIcon from './sparkle-icon.svg?react';
import SpeechBubbleIcon from './speech-bubble-icon.svg?react';
import StarIcon from './star-icon.svg?react';
import StatisticsIcon from './statistics-icon.svg?react';
import TargetIcon from './target-icon.svg?react';
import TeamIcon from './team-icon.svg?react';

export const icons = {
  fileExcel: FileExcelIcon,
  filePdf: FilePdfIcon,
  click: ClickIcon,
  eye: EyeIcon,
  key: KeyIcon,
  qrCode: QRCodeIcon,
  money: MoneyIcon,
  globe: GlobeIcon,
  speechBubble: SpeechBubbleIcon,
  settings: SettingsIcon,
  reportActions: ReportActionsIcon,
  product: ProductIcon,
  sparkle: SparkleIcon,
  statistics: StatisticsIcon,
  team: TeamIcon,
  graph: GraphIcon,
  target: TargetIcon,
  envelope: EnvelopeIcon,
  phone: PhoneIcon,
  export: ExportIcon,
  star: StarIcon,
};

export type TIconName = keyof typeof icons;
